import { useEffect } from 'react'
import { useNavigate } from '@tanstack/react-router'

import { InstallPrompt } from '~/boundedContext/settings/components/install-prompt'
import { PushDailyWordPrompt } from '~/boundedContext/settings/components/push-daily-word-prompt'
import { ReachingLimit } from '~/boundedContext/subscription/components/reaching-limit'
import { FreshAccount } from '~/components/fresh-account'
import { Replication } from '~/components/replication/replication'
import { useRootRedirectTo } from '~/hooks/use-root-redirect-to'
import { MainLayout } from '~/layout/main-layout'

import { UpdatePrompt } from './update-prompt'

export const MainShell = () => {
  const navigate = useNavigate()
  const redirectTo = useRootRedirectTo()

  useEffect(() => {
    if (redirectTo) void navigate({ to: redirectTo, replace: true })
  }, [redirectTo, navigate])

  if (redirectTo) return null

  return (
    <MainLayout>
      <FreshAccount />
      <Replication />
      <PushDailyWordPrompt />
      <ReachingLimit />
      <UpdatePrompt />
      <InstallPrompt />
    </MainLayout>
  )
}
